document.addEventListener("alpine:init", () => {
    Alpine.data("scrollingTextHighlight", () => ({
        scrolling: false,
        paragraphs: false,
        spanLength: 0,
        init() {
            this.visible = true;

            const spans = this.$el.querySelectorAll(
                ".Scrolling-Text-Highlight-word"
            );

            window.addEventListener("scroll", () => {
                if (!this.scrolling) {
                    return;
                }

                const mainContainer = this.$el;
                const textContainer = this.$el.querySelector(
                    ".Scrolling-Text-Content"
                );
                const scrollTrack =
                    mainContainer.offsetHeight - textContainer.offsetHeight;
                const scrollPercent =
                    (textContainer.offsetTop / scrollTrack) * 100;

                if (this.paragraphs) {
                    this.spanLength = spans.length + 2;
                } else {
                    this.spanLength = spans.length;
                }

                const stepSize = 100 / this.spanLength;

                for (let i = 0; i < spans.length; i++) {
                    const span = spans[i];
                    if (scrollPercent >= stepSize * (i + 1)) {
                        span.classList.remove("opacity-10");
                    } else {
                        span.classList.add("opacity-10");
                    }
                }
            });
        },
    }));
});
